"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantManagementPage = TenantManagementPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var message_1 = require("../../../components/dialogs/message");
var building_area_1 = require("../../../features/apis/building-area");
var occupancy_1 = require("../../../features/apis/occupancy");
var tenant_1 = require("../../../features/apis/tenant");
var save_shortcut_1 = require("../../../features/save-shortcut/save-shortcut");
var message_dialog_1 = require("../../../features/thunks/message-dialog");
var hooks_1 = require("../../../store/hooks");
var areas_leases_step_1 = require("./steps/areas-leases-step");
var contacts_invoiced_persons_step_1 = require("./steps/contacts-invoiced-persons-step");
var invoice_settings_step_1 = require("./steps/invoice-settings-step");
var service_customisation_step_1 = require("./steps/service-customisation-step");
var tenant_info_step_1 = require("./steps/tenant-info-step");
var tenant_history_view_1 = require("./tenant-history-view");
/**
 * ATOC-2 §1: "Make the second step (Areas & leases) the first step … Rename this step to Tenancy
 * Configuration (the tenant info step will fall effectually away/capturing the tenant info will be
 * moved into this step)."
 *
 * So the wizard is three steps, not four. Tenant Info is no longer a step of its own — the company
 * details are captured inside Tenancy Configuration, which is also where the buildings, areas and
 * leases live.
 *
 * XInt-2 (D1): Contacts & Invoiced Persons remains hidden; the component and its save handler are kept
 * so the functionality is not lost, just not navigated to.
 */
var steps = [
    { step: 1, label: "Tenancy Configuration", description: "Buildings, tenant details, areas & leases" },
    { step: 2, label: "Service Customisation", description: "Service rates and charges" },
    { step: 3, label: "Invoice Settings", description: "Invoice configuration & cost items" },
];
/**
 * ATOC-1 C2 — Erik: "please change the steps to look like that of the area config (i.e. blue/teal-ish,
 * not green and purple)", and "the user can select any of the steps and proceed (scrolling to the
 * bottom is too tedious…)".
 *
 * So the palette is the area config's `primary`, and every step is clickable rather than only the
 * completed ones. The one exception is a tenant that does not exist yet: steps 2-4 all write against
 * a tenantId, so during creation they stay locked until step 1 has saved.
 */
function StepIndicator(props) {
    var currentStep = props.currentStep, completedSteps = props.completedSteps, canNavigate = props.canNavigate, onStepClick = props.onStepClick;
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center gap-0", children: steps.map(function (s, idx) {
            var isActive = s.step === currentStep;
            var isCompleted = completedSteps.has(s.step);
            var isClickable = !isActive && (canNavigate || isCompleted);
            return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center", children: [(0, jsx_runtime_1.jsxs)(react_1.Button, { type: "button", variant: "light", disableAnimation: true, className: "h-auto min-w-0 flex-col items-center gap-1 rounded-lg px-3 py-2 data-[hover=true]:bg-gray-100 ".concat(isActive ? "bg-primary/10" : "", " ").concat(isClickable ? "cursor-pointer" : "cursor-default"), onPress: function () { return isClickable && onStepClick(s.step); }, isDisabled: !isClickable && !isActive, children: [(0, jsx_runtime_1.jsx)("div", { className: "flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold transition-colors ".concat(isActive ? "bg-primary text-white" : isCompleted ? "bg-primary/20 text-primary" : "bg-gray-100 text-gray-400"), children: isCompleted && !isActive ? (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:check-read-linear", className: "text-lg" }) : s.step }), (0, jsx_runtime_1.jsxs)("div", { className: "text-center", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-xs font-semibold ".concat(isActive ? "text-primary" : isCompleted ? "text-primary/70" : "text-gray-400"), children: s.label }), (0, jsx_runtime_1.jsx)("p", { className: "hidden text-xs text-gray-400 sm:block", children: s.description })] })] }), idx < steps.length - 1 && (0, jsx_runtime_1.jsx)("div", { className: "mx-1 h-px w-8 transition-colors ".concat(isCompleted ? "bg-primary/40" : "bg-gray-200") })] }, s.step));
        }) }));
}
function TenantManagementPage() {
    var _this = this;
    var _a, _b, _c;
    var urlTenantId = (0, react_router_dom_1.useParams)().tenantId;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var clientId = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }).clientId;
    var isCreateMode = !urlTenantId;
    // Tenant ID resolved after step 1 save (create) or from URL (edit)
    var _d = (0, react_3.useState)(urlTenantId ? urlTenantId : null), activeTenantId = _d[0], setActiveTenantId = _d[1];
    /*
     * Follow the URL when it changes.
     *
     * `useState` above reads the param once, at mount. Navigating from /tenants/A to /tenants/B keeps
     * this same component mounted — React Router does not remount for a param change on the same route —
     * so without this the address bar moved but the page carried on showing tenant A. That is what made
     * the duplicate warning's "Open tenant" button look like it did nothing.
     *
     * The wizard state is reset with it: step, completed steps and the areas saved from the previous
     * tenant all belong to the tenant being left behind.
     */
    (0, react_3.useEffect)(function () {
        if (!urlTenantId)
            return;
        if (urlTenantId === activeTenantId)
            return;
        setActiveTenantId(urlTenantId);
        setCurrentStep(1);
        setCompletedSteps(new Set([1]));
        setSavedAreaIds([]);
    }, [urlTenantId, activeTenantId]);
    // Top-level tab — Manage (the wizard) vs History. Hidden in create mode.
    var _e = (0, react_3.useState)("manage"), topTab = _e[0], setTopTab = _e[1];
    var dispatch = (0, hooks_1.useAppDispatch)();
    var getDirtyLabels = (0, save_shortcut_1.useDirtyLabels)();
    var saveAll = (0, save_shortcut_1.useSaveAll)();
    // Steps state
    var _f = (0, react_3.useState)(1), currentStep = _f[0], setCurrentStep = _f[1];
    var _g = (0, react_3.useState)(isCreateMode ? new Set() : new Set([1])), completedSteps = _g[0], setCompletedSteps = _g[1];
    // Area IDs saved from step 2. Kept only to advance the wizard — step 3 no longer depends on it.
    var _h = (0, react_3.useState)([]), savedAreaIds = _h[0], setSavedAreaIds = _h[1];
    // Fetch existing tenant (for edit mode / after step 1 create)
    var _j = (0, tenant_1.useFetchTenantQuery)(activeTenantId !== null && activeTenantId !== void 0 ? activeTenantId : "", { skip: !activeTenantId }), tenantData = _j.data, tenantLoading = _j.isLoading;
    var existingTenant = (_a = tenantData === null || tenantData === void 0 ? void 0 : tenantData.content) !== null && _a !== void 0 ? _a : undefined;
    var allAreasData = (0, building_area_1.useFetchAllClientBuildingAreasQuery)({ clientId: clientId }, { skip: !clientId }).data;
    // Every area this tenant holds a lease on.
    var tenantOccupanciesData = (0, occupancy_1.useFetchClientOccupanciesQuery)({ clientId: clientId, tenantId: activeTenantId !== null && activeTenantId !== void 0 ? activeTenantId : "", page: 1, limit: 1000 }, { skip: !clientId || !activeTenantId }).data;
    /**
     * Erik: "when I go to the Service Customisation, please show all the leased areas, showing all the
     * active leases first and then the inactive leases thereafter" and "It should not require the user
     * to click on service customisation after saving changes in the Areas&lease step."
     *
     * Both come from the same fix: derive this from the tenant's OCCUPANCIES rather than from the area
     * ids step 2 happened to hand over in this session. The old version was populated only when step 2's
     * Next button fired, so arriving at step 3 any other way — including clicking the step directly,
     * which ATOC-1 C2b made possible — showed an empty screen.
     *
     * A lease is active while it has started, is not soft-deleted, and has not passed its vacation date.
     * Same test the Areas & Leases step uses, so the two screens cannot disagree about who is sitting
     * where.
     */
    var selectedAreas = (0, react_3.useMemo)(function () {
        var _a, _b;
        var occupancies = ((_a = tenantOccupanciesData === null || tenantOccupanciesData === void 0 ? void 0 : tenantOccupanciesData.content) === null || _a === void 0 ? void 0 : _a.occupancies) || [];
        if (occupancies.length === 0)
            return [];
        var allAreas = ((_b = allAreasData === null || allAreasData === void 0 ? void 0 : allAreasData.content) === null || _b === void 0 ? void 0 : _b.buildingAreas) || [];
        var today = new Date().toISOString().slice(0, 10);
        var rows = occupancies
            .map(function (occ) {
            var found = allAreas.find(function (a) { return a._id === occ.areaId; });
            if (!found)
                return null;
            var o = occ;
            var ended = !!occ.vacationDate && occ.vacationDate.slice(0, 10) < today;
            var isActive = !o.deleted && (!o.status || o.status === "Active") && !ended;
            return {
                areaId: found._id,
                areaNumber: found.areaNumber,
                buildingId: found.buildingId,
                buildingName: found.buildingName,
                isActive: isActive,
            };
        })
            .filter(Boolean);
        // Active first, then inactive; alphabetical within each group.
        return rows.sort(function (a, b) {
            if (a.isActive !== b.isActive)
                return a.isActive ? -1 : 1;
            return a.areaNumber.localeCompare(b.areaNumber, "en", { numeric: true, sensitivity: "base" });
        });
    }, [tenantOccupanciesData, allAreasData]);
    var tenantName = (_b = existingTenant === null || existingTenant === void 0 ? void 0 : existingTenant.name) !== null && _b !== void 0 ? _b : "New Tenant";
    var tenantCode = (_c = existingTenant === null || existingTenant === void 0 ? void 0 : existingTenant.tenantCode) !== null && _c !== void 0 ? _c : "";
    var markCompleted = function (step) {
        setCompletedSteps(function (prev) {
            var next = new Set(prev);
            next.add(step);
            return next;
        });
    };
    /*
     * ATOC-2 §1: three steps now, with tenant details and leases both inside step 1. Saving the tenant
     * no longer advances the wizard — it reveals the areas below it, because Erik's order is "once the
     * building is selected, the user must be able to populate the tenant information".
     */
    var handleTenantSaved = function (tenantId) {
        setActiveTenantId(tenantId);
        markCompleted(1);
    };
    var handleLeasesSaved = function (areaIds) {
        setSavedAreaIds(areaIds);
        markCompleted(1);
        setCurrentStep(2);
    };
    var handleServiceCustomisationFinish = function () {
        markCompleted(2);
        setCurrentStep(3);
    };
    var handleInvoiceSettingsFinish = function () {
        // XInt-2 (D1): Contacts & Invoiced Persons is hidden — the wizard finishes after Invoice Settings.
        markCompleted(3);
        navigate("/dashboard/tenants");
    };
    var handleContactsFinish = function () {
        markCompleted(4);
        navigate("/dashboard/tenants");
    };
    /**
     * ATOC-1 C2: "if the user made changes that have not been saved, the user should be prompted whether
     * it must be saved and continued or whether it should be discarded. But if the user did save it
     * before continuing then it should just go to the next step when the user clicks on it."
     *
     * Discarding is simply navigating: each step owns its own form state and is unmounted on the way
     * out, so the edits go with it. Nothing is written on the discard path.
     */
    var handleStepClick = function (step) { return __awaiter(_this, void 0, void 0, function () {
        var dirty, choice, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dirty = getDirtyLabels();
                    if (dirty.length === 0) {
                        setCurrentStep(step);
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, dispatch((0, message_dialog_1.showMessageDialogThunk)({
                            header: "Unsaved changes",
                            body: "You have unsaved changes on this step (".concat(dirty.join(", "), "). Save them before moving on?"),
                            buttons: [
                                { type: message_1.EMessageDialogButtonType.CANCEL, label: "Stay here", variant: "light" },
                                { type: message_1.EMessageDialogButtonType.DISCARD, label: "Discard", variant: "flat" },
                                { type: message_1.EMessageDialogButtonType.OK, label: "Save & continue", variant: "solid" },
                            ],
                        })).unwrap()];
                case 2:
                    choice = _b.sent();
                    if (choice === message_1.EMessageDialogButtonType.DISCARD) {
                        setCurrentStep(step);
                        return [2 /*return*/];
                    }
                    if (!saveAll) return [3 /*break*/, 4];
                    return [4 /*yield*/, saveAll()];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    setCurrentStep(step);
                    return [3 /*break*/, 6];
                case 5:
                    _a = _b.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    if (tenantLoading && !isCreateMode) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "flex h-full items-center justify-center", children: (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" }) }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "rounded-xl bg-white p-6 shadow-sm", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-start justify-between gap-4", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(react_1.Breadcrumbs, { size: "sm", className: "mb-1", children: [(0, jsx_runtime_1.jsx)(react_1.BreadcrumbItem, { onPress: function () { return navigate("/dashboard/tenants"); }, children: "Tenants" }), (0, jsx_runtime_1.jsx)(react_1.BreadcrumbItem, { children: isCreateMode ? "Create Tenant" : tenantName })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-2xl font-semibold text-gray-900", children: isCreateMode ? "New Tenant" : tenantName }), tenantCode && ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: "primary", className: "font-mono", children: tenantCode })), !isCreateMode && existingTenant && ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: existingTenant.isActive ? "success" : "danger", children: existingTenant.isActive ? "Active" : "Inactive" }))] })] }), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:arrow-left-linear" }), onPress: function () { return navigate("/dashboard/tenants"); }, children: "Back to Tenants" })] }), !isCreateMode && activeTenantId && ((0, jsx_runtime_1.jsx)("div", { className: "mt-4 border-b border-gray-100", children: (0, jsx_runtime_1.jsxs)(react_1.Tabs, { "aria-label": "Tenant management", variant: "underlined", color: "primary", selectedKey: topTab, onSelectionChange: function (k) { return setTopTab(String(k)); }, classNames: {
                                tabList: "gap-6",
                                tab: "px-0 h-10",
                                panel: "hidden",
                            }, children: [(0, jsx_runtime_1.jsx)(react_1.Tab, { title: (0, jsx_runtime_1.jsxs)("span", { className: "flex items-center gap-1", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:settings-linear", className: "text-base" }), "Manage"] }) }, "manage"), (0, jsx_runtime_1.jsx)(react_1.Tab, { title: (0, jsx_runtime_1.jsxs)("span", { className: "flex items-center gap-1", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:history-linear", className: "text-base" }), "History"] }) }, "history")] }) })), topTab === "manage" && ((0, jsx_runtime_1.jsx)("div", { className: "mt-6", children: (0, jsx_runtime_1.jsx)(StepIndicator, { currentStep: currentStep, completedSteps: completedSteps, 
                            // Steps 2-4 all write against a tenantId, so during creation they stay locked until step 1 saves.
                            canNavigate: !!activeTenantId, onStepClick: handleStepClick }) }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "rounded-xl bg-white p-6 shadow-sm", children: [topTab === "manage" && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [currentStep === 1 && ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-6", children: activeTenantId ? ((0, jsx_runtime_1.jsx)(areas_leases_step_1.AreasLeasesStep, { tenantId: activeTenantId, tenantName: tenantName, mode: isCreateMode ? "create" : "edit", onSaved: handleLeasesSaved, tenantDetailsSlot: (0, jsx_runtime_1.jsx)(tenant_info_step_1.TenantInfoStep, { tenantId: activeTenantId, existingTenant: existingTenant, mode: "edit", isCreationFlow: isCreateMode, onSaved: handleTenantSaved, variant: "embedded" }) })) : ((0, jsx_runtime_1.jsx)(tenant_info_step_1.TenantInfoStep, { tenantId: activeTenantId, existingTenant: existingTenant, mode: "create", isCreationFlow: isCreateMode, onSaved: handleTenantSaved, variant: "embedded" })) })), currentStep === 2 && (0, jsx_runtime_1.jsx)(service_customisation_step_1.ServiceCustomisationStep, { areas: selectedAreas, tenantId: activeTenantId, onFinish: handleServiceCustomisationFinish }), currentStep === 3 && activeTenantId && ((0, jsx_runtime_1.jsx)(invoice_settings_step_1.InvoiceSettingsStep, { areas: selectedAreas, tenantId: activeTenantId, onFinish: handleInvoiceSettingsFinish })), currentStep === 4 && activeTenantId && ((0, jsx_runtime_1.jsx)(contacts_invoiced_persons_step_1.ContactsInvoicedPersonsStep, { areas: selectedAreas, tenantId: activeTenantId, isCreationFlow: isCreateMode, onFinish: handleContactsFinish })), currentStep > 1 && !activeTenantId && ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center justify-center py-16 text-gray-400", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:lock-linear", className: "mb-2 text-4xl" }), (0, jsx_runtime_1.jsx)("p", { className: "text-sm", children: "Capture the tenant in Tenancy Configuration first to unlock the later steps." }), (0, jsx_runtime_1.jsx)(react_1.Button, { className: "mt-4", variant: "flat", color: "primary", onPress: function () { return setCurrentStep(1); }, children: "Go to Tenancy Configuration" })] }))] })), topTab === "history" && activeTenantId && (0, jsx_runtime_1.jsx)(tenant_history_view_1.TenantHistoryView, { tenantId: activeTenantId, showAuditLog: true })] })] }));
}
